import { render, staticRenderFns } from "./mellat.vue?vue&type=template&id=c850e164"
import script from "./mellat.vue?vue&type=script&lang=js"
export * from "./mellat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports